import { Grid } from "@mui/material";
import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import AllEntitiesPieCharts from "../../../components/Table/Dashboard/AllEntities/AllEntitiesPieCharts";
import CustomStackedBarChart from "../../../components/Table/Dashboard/AllEntities/CustomStackedBarChart";
import { Spinner } from "../../../components/Loading/Spinner";
import { useAllSuscripsDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllSuscriptions";

const AllSuscriptionsDashboard = () => {
  const {
    isLoadingTotalCredits,
    totalCredits,
    totalCreditsFilters,
    handleToggleCredit,
  } = useAllSuscripsDashboard();

  if (isLoadingTotalCredits) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <SelectTypeOfDashboard routeValue="suscriptions">
      <AllEntitiesPieCharts
        credits={totalCredits}
        title="Total suscripciones"
        label="plan"
      />
      <CustomStackedBarChart
        credits={totalCredits}
        label="plan"
        id="id_suscripcion"
        totalCreditsFilters={totalCreditsFilters}
        handleToggleCredit={handleToggleCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default AllSuscriptionsDashboard;
